import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { DnaMwCalc } from "../components/DnaMwCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.dnamw_tool_name()}
        toolPath="/dna-rna-molecular-weight"
      />
      <SciHeader title={m.dnamw_h1()} intro={m.dnamw_intro()} />

      <DnaMwCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.dnamw_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.dnamw_ex1(), m.dnamw_ex2(), m.dnamw_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.dnamw_faq_q1(), a: m.dnamw_faq_a1() },
          { q: m.dnamw_faq_q2(), a: m.dnamw_faq_a2() },
          { q: m.dnamw_faq_q3(), a: m.dnamw_faq_a3() },
          { q: m.dnamw_faq_q4(), a: m.dnamw_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
